import { useEffect, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

interface RecaptchaWidgetProps {
  hl?: string;
  onChange: (token: string) => void;
}

const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string | undefined;
const IS_DEV = !SITE_KEY;

/**
 * Wraps react-google-recaptcha.
 * In development (no VITE_RECAPTCHA_SITE_KEY), renders a labelled placeholder
 * and immediately fires onChange with a mock token so forms remain usable.
 */
export function RecaptchaWidget({ hl, onChange }: RecaptchaWidgetProps) {
  const ref = useRef<ReCAPTCHA>(null);

  // In dev, fire once on mount so the submit button unlocks
  useEffect(() => {
    if (IS_DEV) {
      onChange("dev-mock-token");
    }
  }, [onChange]);

  if (IS_DEV) {
    return (
      <div className="flex items-center gap-2 rounded border border-dashed border-muted-foreground/40 bg-muted/30 px-4 py-3 text-sm text-muted-foreground">
        <span className="text-xs font-mono">[reCAPTCHA — dev mode, skipped]</span>
      </div>
    );
  }

  return (
    <ReCAPTCHA
      ref={ref}
      sitekey={SITE_KEY!}
      hl={hl}
      onChange={(token) => onChange(token ?? "")}
    />
  );
}
